<div class="main">
    @if (subscribeItem) {
    <app-schedule-subscription [subscribeItem]="subscribeItem" [selectionsFromReport]="selectionsFromReport"
        (clearSubscribeItem)="closeSubscribe()">
    </app-schedule-subscription>
    }

    <!-- Hidden, not removed, while the subscription form is open, so the embedded report stays loaded -->
    <div class="report-view" [style.display]="subscribeItem ? 'none' : null">
        <div class="breadcrumbs">
            <f-breadcrumb divider=">" [breadcrumbItems]="items" (breadcrumbSelected)="onBreadcrumbSelected($event)">
            </f-breadcrumb>
        </div>

        <h1>{{ contentTitle }}</h1>

        @if (showExport || showSubscribe) {
        <div class="report-export" role="group" aria-label="Report actions">
            @if (showExport) {
            <f-overflow-menu variant="action" [overflowText]="'Export'" [overflowItems]="exportItems"
                [overflowIconConfig]="exportIconConfig" is-icon-only="false" uuid="report-export-menu"
                (overflowItemSelected)="onExportSelected($event)">
            </f-overflow-menu>
            }
            @if (showSubscribe) {
            <f-button text="Subscribe" variant="action" [disabled]="!canSubscribe" (buttonClicked)="subscribeFromReport()"></f-button>
            }
            <span class="report-export-status" role="status" aria-live="polite">{{ exportMessage }}</span>
        </div>
        }

        <!-- Your existing dashboard container -->
        <div id="dashboard-container" class="dashboard-container">
        </div>
    </div>
</div>
